export const DEFAULT_SEVERITY_CONFIG = Object.freeze({
    burnFloor: 0.25,
    directionMultiplier: 1.5,
    bandThresholdsCents: Object.freeze([
        { band: 'Critical', minScore: 1_500_000 }, // $15,000
        { band: 'High', minScore: 500_000 }, //      $5,000
        { band: 'Medium', minScore: 100_000 }, //     $1,000
        { band: 'Low', minScore: 0 },
    ]),
});
//# sourceMappingURL=config.js.map